import api from "../../api.service";
import store from "../";

const state = {
    about: {
        description: "",
        address: "",
        mobileNumber: "",
        phoneNumber: "",
        facebookLink: "",
        email: "",
        instagramLink: "",
        telegramLink: "",
        shopsCount: 0,
        usersCount: 0,
        allowed: false
    }
};

const getters = {
    about(state) {
        return state.about;
    }
};

const mutations = {
    GET_ABOUT_ITEM(state, payload) {
        Object.assign(state.about, payload);
        store.dispatch("setLoading", false);
    },

    UPDATE_ABOUT_ITEM(state, payload) {
        state.about = payload;
    }
};

const actions = {
    async fetchAbout(context) {
        const { data } = await api
            .query(`/api/Settings/GetSettings`)
            .then(data => data);
        context.commit("GET_ABOUT_ITEM", data);
    },

    async setAbout(context, payload) {
        const { data } = await api
            .post(`/api/Settings/SetSettings`, {
                Description: payload.description,
                Address: payload.address,
                MobileNumber: payload.mobileNumber,
                PhoneNumber: payload.phoneNumber,
                FacebookLink: payload.facebookLink,
                Email: payload.email,
                InstagramLink: payload.instagramLink,
                TelegramLink: payload.telegramLink,
                WhatsappLink: payload.whatsappLink,
                ShopsCount: +payload.shopsCount,
                UsersCount: +payload.usersCount
            })
            .then(data => data);
        context.commit("UPDATE_ABOUT_ITEM", data);
    }
};

const aboutManagement = {
    state,
    getters,
    actions,
    mutations
};
export default aboutManagement;
